// 人物信息頁面翻譯
export default {
  // 輸入框佔位符
  placeholders: {
    name: "請輸入姓名",
    homePlace: "請輸入籍貫",
    suspicionLevel: "請選擇嫌疑程度",
    idNumber: "請輸入身份證號",
    role: "請輸入角色",
    phone: "請輸入手機號，多個用逗號隔開",
    email: "請輸入郵箱，多個用逗號隔開",
    caseSearch: "請輸入案件名稱查詢並選擇案件，可多選",
    surveySearch: "請輸入調證用戶ID查詢並選擇調證用戶，可多選",
    traceJudgment: "請輸入軌跡研判",
    infoStreamJudgment: "請輸入信息流研判",
    assetJudgment: "請輸入資產流研判",
    phoneListInfo: "請輸入手機列裝情況",
    companyUnderName: "請選擇名下公司情況",
    actualControlAddress: "請輸入實控地址",
    chineseIdentity: "請輸入身份",
    remark: "請輸入備註",
    region: "請選擇地區",
  },

  // 按鈕
  buttons: {
    reset: "重置",
    search: "查詢",
    addCharacter: "添加人物",
    view: "查看",
    delete: "刪除",
    cancel: "取消",
    confirm: "確認",
    edit: "編輯",
    save: "保存",
    duplicateCheck: "重複校驗",
    goEdit: "去編輯",
  },

  // 統計信息
  statistics: {
    total: "共計",
    totalData: "條數據",
  },

  // 表格列標題
  table: {
    name: "姓名",
    homePlace: "籍貫",
    suspicionLevel: "嫌疑程度",
    traceJudgment: "軌跡研判",
    infoStreamJudgment: "信息流研判",
    assetJudgment: "資產流研判",
    sourceType: "數據來源",
    updateTime: "更新時間",
    action: "操作",
  },

  // 對話框標題
  dialogs: {
    detail: "人物詳情",
    create: "新增人物",
    edit: "人物編輯",
    deleteConfirm: "刪除確認",
    deleteMessage: "此操作將永久刪除{name}人物信息，是否確定?",
    duplicateWarning: "提示",
    duplicateMessage:
      '當前身份證號已存在人物信息，人物姓名為"{name}"，請確認是否需要編輯該人物信息？',
  },

  // 表單標籤
  labels: {
    name: "姓名",
    region: "地區",
    suspicionLevel: "嫌疑程度",
    idNumber: "身份證號",
    homePlace: "籍貫",
    role: "角色",
    phone: "手機號",
    email: "郵箱",
    gcCase: "圖鏈案件",
    backendCase: "後台case",
    relatedSurvey: "關聯調證",
    traceJudgment: "軌跡研判",
    infoStreamJudgment: "信息流研判",
    assetJudgment: "資產流研判",
    phoneListInfo: "手機列裝情況",
    companyUnderName: "名下公司",
    actualControlAddress: "實控地址",
    chineseIdentity: "中國身份",
    remark: "備註",
    updateTime: "更新時間",
    lastOperator: "最近操作人",
    sourceType: "數據來源",
    // 編輯頁面特有標籤（調證/人工分類）
    phoneSurvey: "手機號(調證)",
    phoneManual: "手機號(人工)",
    emailSurvey: "郵箱(調證)",
    emailManual: "郵箱(人工)",
    gcCaseSurvey: "圖鏈案件(調證)",
    gcCaseManual: "圖鏈案件(人工)",
    relatedSurveySurvey: "關聯調證(調證)",
    relatedSurveyManual: "關聯調證(人工)",
  },

  // 提示信息
  messages: {
    noData: "暫無數據",
    loading: "拼命加載中",
    deleteSuccess: "刪除成功",
    deleteCancelled: "已取消刪除",
    createSuccess: "新增成功",
    createFailed: "新增失敗",
    editSuccess: "編輯成功",
    editFailed: "編輯失敗",
    saveFailed: "保存失敗，請稍後再試",
    checkFailed: "校驗失敗，請稍後再試",
    enterIdFirst: "請先輸入身份證號",
    fetchFailed: "獲取人物信息失敗",
  },
};
